const SET_UPLOAD_LIST = '@upload/set-upload-list';
const SET_UPLOAD_DETAIL = '@upload/set-upload-detail';
const SET_UPLOAD_LIST_TOTAL = '@upload/set-upload-list-total';
const SET_UPLOAD_DETAIL_TOTAL = '@upload/set-upload-detail-total';

export {SET_UPLOAD_LIST, SET_UPLOAD_DETAIL, SET_UPLOAD_LIST_TOTAL, SET_UPLOAD_DETAIL_TOTAL};